var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-fade-transition',[_c('router-view',{staticStyle:{"margin-left":"-40px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }